/* Pingion Games - cart drawer helper.
   1) AJAX add-to-cart zodat de winkelmand-drawer opent bij toevoegen.
   2) Houdt het mandje-aantal in de header actueel na elke wijziging.
   Gewone /cart/add formulieren worden onderschept; <product-form> laat het aan Dawn over. */
(function () {
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    e.preventDefault();

    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { form.submit(); return; }
        var html = res && res.sections && res.sections['cart-drawer'];
        if (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('#CartDrawer');
          var live = cd.querySelector('#CartDrawer');
          if (fresh && live) {
            live.innerHTML = fresh.innerHTML;
            cd.classList.remove('is-empty');
            var inner = cd.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            var overlay = cd.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof cd.close === 'function') {
              overlay.addEventListener('click', cd.close.bind(cd));
            }
          }
        }
        if (typeof cd.open === 'function') cd.open();
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-disabled');
      });
  }

  function init() {
    document.addEventListener('submit', handleSubmit, false);
    var cd = document.querySelector('cart-drawer');
    if (cd && 'MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(refreshCount, 250);
      }).observe(cd, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
